import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

// Spotlight / clipped-frame portfolio card.
export default function PortfolioCard({ project, index = 0, large = false }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.65, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`portfolio-card-${project.id}`}
      className={[
        "group relative overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03]",
        large ? "lg:col-span-2" : "",
      ].join(" ")}
    >
      <div className={["relative overflow-hidden", large ? "h-72 sm:h-96" : "h-64"].join(" ")}>
        <img
          src={project.image}
          alt={project.name}
          className={[
            "h-full w-full object-cover transition-[transform,opacity] duration-[800ms] group-hover:scale-105",
            project.placeholder ? "opacity-30 grayscale" : "opacity-80 group-hover:opacity-100",
          ].join(" ")}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
        {/* spotlight sweep */}
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_var(--x,50%)_var(--y,0%),rgba(255,90,54,0.18),transparent_55%)] opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
        <span className="absolute left-6 top-6 rounded-full border border-white/15 bg-ink/60 px-3 py-1 text-[11px] font-medium uppercase tracking-wider text-brand-gold backdrop-blur-md">
          {project.category}
        </span>
      </div>

      <div className="p-8">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-heading text-xl font-semibold text-white">{project.name}</h3>
          <ArrowUpRight className="h-5 w-5 shrink-0 text-muted-foreground transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-brand" />
        </div>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{project.desc}</p>

        <div className="mt-5 flex flex-wrap gap-2">
          {project.tech.map((t) => (
            <span key={t} className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/70">
              {t}
            </span>
          ))}
        </div>

        {project.outcome && (
          <div className="mt-6 border-t border-white/10 pt-5">
            <p className="text-xs uppercase tracking-wider text-white/40">Outcome</p>
            <p className="mt-1.5 text-sm text-white/80">{project.outcome}</p>
          </div>
        )}
      </div>
    </motion.article>
  );
}
